import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';                    // This will act as your layout/root component
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import DataRAGChat from './Rag';
import CallbackPage from './CallBackPage';
import Dash from './Dashboard';
import BeachDashboard from './Beach';
import AffordabilityPage from './Affordabilitypage';

// Import your other page components here
// Example:
// import Home from './pages/Home';
// import About from './pages/About';
// import NotFound from './pages/NotFound';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />
  },
  {
        path: 'v1/callback',         // ← Add this exact path
        element: <CallbackPage />,   // or <MsalRedirectHandler />
      },
    {
    path: '/rag',
    element: <DataRAGChat />
  },

  {
    path: '/affordability',
    element: <AffordabilityPage />
  },

   {
    path: '/beach-report',
    element: <BeachDashboard />
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);